import { Box, styled } from '@mui/material'
import { Typography } from '@carto/meridian-ds/components'

const Description = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(0.5),
  display: 'block'
}))

export default function HomeAppCardInfo({
  title,
  description,
  displayDescription
}: {
  title: string
  description: string
  displayDescription: boolean
}) {
  return (
    <Box ml={2}>
      <Typography variant="subtitle1">{title}</Typography>
      {displayDescription && <Description variant="body2">{description}</Description>}
    </Box>
  )
}
